/**
 * home-top.js — TOPセクションの最小JS (CHG-086 / DEV-HERO)
 *
 * 1. Why SHOGUN? SPナンバータブ (tablist / タップ切替のみ / 矢印キー対応 / カード高さ固定=CLS防止)。
 *    JS無しでは全パネルが縦積みで読める（data-tabs-ready が付くまで非表示制御は効かない）。
 * 2. FAQ 開封計測 shogun_top_faq_open（設問ごと初回のみ）。
 * 3. Voicesカルーセルのスクロール計測 shogun_top_reviews_scroll（1ページ1回・passive）。
 * GA4への転送はカスタムピクセル側の購読が前提（DEV-B連携・req-dev-hero.md A-2-7）。
 * 外部ライブラリなし（G-04）。
 */
(function () {
  'use strict';

  function publish(name, data) {
    if (
      typeof window.Shopify === 'object' &&
      window.Shopify !== null &&
      window.Shopify.analytics &&
      typeof window.Shopify.analytics.publish === 'function'
    ) {
      try {
        window.Shopify.analytics.publish(name, data);
      } catch (e) {
        /* 計測で落とさない */
      }
    }
  }

  function initWhyTabs() {
    var root = document.querySelector('.sh-why');
    if (!root) return;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('.sh-why__tab'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('.sh-why__panel'));
    if (tabs.length === 0 || panels.length !== tabs.length) return;

    var mq = window.matchMedia('(max-width: 749px)');

    function lockHeight() {
      // カーンFB 2026-08-31: カードは Figma (1:925) どおりコンテンツフィットにする。
      // 旧実装の「3パネル最大高で minHeight 固定」は短いパネルの下に余白を作るため停止し、
      // クリア専用に変更 (PC復帰時の解除バグ対策 2026-08-30 も本クリアで引き続き担保)。
      panels.forEach(function (panel) {
        panel.style.minHeight = '';
      });
    }

    function select(index) {
      tabs.forEach(function (tab, i) {
        var on = i === index;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
      });
      panels.forEach(function (panel, i) {
        panel.classList.toggle('is-active', i === index);
      });
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        select(i);
      });
      tab.addEventListener('keydown', function (event) {
        var delta = 0;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') delta = 1;
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') delta = -1;
        else return;
        event.preventDefault();
        var next = (i + delta + tabs.length) % tabs.length;
        select(next);
        tabs[next].focus();
      });
    });

    // tabpanelロールはSPタブが実際に動く時だけ付与する
    // (PCではタブ非表示のため、参照先の無い aria-labelledby を静的HTMLに残さない)
    panels.forEach(function (panel, i) {
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', tabs[i].id);
      panel.tabIndex = 0;
    });

    root.setAttribute('data-tabs-ready', '');
    lockHeight();
    window.addEventListener('resize', lockHeight, { passive: true });
  }

  function initFaqTracking() {
    var items = document.querySelectorAll('details.sh-faq__item');
    Array.prototype.forEach.call(items, function (item) {
      var sent = false;
      item.addEventListener('toggle', function () {
        if (!item.open || sent) return;
        sent = true;
        publish('shogun_top_faq_open', { faq_id: item.getAttribute('data-faq-id') || '' });
      });
    });
  }

  function initVoicesTracking() {
    var track = document.querySelector('.sh-voices__track');
    if (!track) return;
    var sent = false;
    // scroll-snap の初期吸着で scrollLeft が0以外から始まり得るため、
    // 固定閾値ではなく「初期位置からの差分」で判定する (liquid-reviewer M-3・偽発火防止)
    var baseline = null;
    track.addEventListener(
      'scroll',
      function () {
        if (baseline === null) baseline = track.scrollLeft;
        if (sent || Math.abs(track.scrollLeft - baseline) <= 40) return;
        sent = true;
        var card = track.querySelector('.sh-voices__card');
        var step = card ? card.offsetWidth + 16 : 316;
        publish('shogun_top_reviews_scroll', { max_card_index: Math.round(track.scrollLeft / step) });
      },
      { passive: true }
    );
  }

  function init() {
    initWhyTabs();
    initFaqTracking();
    initVoicesTracking();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
